export default __webpack_public_path__ + "static/media/team111.b01fa1bf.JPG";